module.exports = __webpack_public_path__ + "img/jinjia_w.f76e498.png";